// 全局常量
export const USER_INFO = 'USER_INFO';
export const SYSTEM_INFO = 'SYSTEM_INFO';
export const WECHAT_OPENID = 'WECHAT_OPENID';
export const VERIFY_TIMESTAMP = 'VERIFY_TIMESTAMP_';
export const SEARCH_HISTORY_LIST = 'SEARCH_HISTORY_LIST';
/** 首页公告弹窗时间缓存KEY */
export const HOME_NOTICE_POPUP_TIME = 'HOME_NOTICE_POPUP_TIME';
export const LOCATION_INFO = 'LOCATION_INFO';
